<div class="row form">
    <div class="col-lg-12 col-md-12 col-sm-12 col-12">
      <app-packagetour-menutab [isEdit]="isEdit" [nameMenu]="nameMenu" [branchofficeSlug]="branchofficeSlug"
        [checkId]="checkId"></app-packagetour-menutab>
    </div>
    <div class="col-lg-12 col-md-12 col-sm-12 col-12">
      <div class="page-title-box form__head">
        <div class="row align-items-center">
          <div class="col-sm-6 col-6">
            <a class="page-title form__head__title" (click)="cancel()">
              <i class="fas fa-arrow-left m-r-5"></i>Galería fotos / {{item.value.description}}<span
                class="text-success"></span>
            </a>
          </div>
          <div class="col-sm-6 col-6 form__head__boxBtn">
            <a class="btn btn-light d-inline" (click)="refresh()"><i class="fas fa-undo"></i> Recargar</a>
          </div>
        </div>
      </div>
    </div>
  
    <div class="col-lg-12">
        <div class="card m-b-30">
          <div class="card-body">
            <form validate [formGroup]="item" (ngSubmit)="onSubmit()">
              <div class="row">
                <div class="col-lg-12">
                  <div class="row">
                      <span class="badge badge-secondary bold">
                          El peso de las imágenes deben ser menor a 0.5 MB
                      </span>
                    <div class="text-right col-12">
                      <span class="badge badge-warning text-dark bold">
                        <i class="fas fa-info-circle m-r-5"></i>
                        No olvider guardar para aplicar cambios
                      </span>
                    </div>
                    <div class="col-lg-3">
                      <p class="text-center p-t-15">
                        <ng-container *ngIf="item.value.url_image != null">
                          <img width="200" height="165" src="tenants/{{item.value.url_image}}" alt="Preview">
                        </ng-container>
                        <ng-container *ngIf="item.value.url_image == null">
                          <ng-container *ngIf="imageUrl == null">
                            <img id="output" width="200" src="/images/default.png" />
                          </ng-container>
                          <ng-container *ngIf="imageUrl != null">
                            <img width="200" height="165" [src]="imageUrl" alt="Preview">
                          </ng-container>
                        </ng-container>
                      </p>
    
                      <p class="text-center">
                        <label for="file" style="cursor: pointer" class="m-b-0"><i class="fas fa-upload"></i>
                          Seleccionar Imagen Portada
                          <input id="file" type="file" (change)="onFileSelected($event)" accept=".png, .jpg, .jpeg"
                            style="visibility: hidden;">
                        </label>                     
                      </p>
                    </div>

                    <div class="col-lg-9">
                        <div class="loading content_loading" id="box-loading-gallery">
                            <div class="spinner" role="status">
                                <div class="inner one"></div>
                                <div class="inner two"></div>
                                <div class="inner three"></div>
                            </div> 
                            <p id="text">Cargando...</p>
                        </div>

                        <button type="button" data-toggle="modal" data-target="#openExtendsGalleryTourism"
                          class="btn btn-outline-info btn-extends" (click)="GalleryTourismComponent.loadData()"><i class="fa fa-plus m-r-5"></i>
                          Seleccionar imágenes
                        </button>

                        <div class="row m-t-10">
                          <ng-container *ngIf="photosOld.length > 0">
                            <div class="row" #sortableContainer>
                              <div class="col-lg-3 m-b-35 p-l-10 p-r-10" *ngFor="let file of photosOld; let index_ = index; trackBy: trackById"
                                [attr.data-id]="file.id" style="cursor: move;">
                                <img style="width: 100%; height: 80%; border-radius: 4px;" src="tenants/{{ file.url_image }}"
                                  alt="Image Preview" />
                                <div class="row m-t-5">
                                  <div class="col-lg-12">
                                    <span (click)="removeImageOld(index_)" class="f-s-14">
                                      Quitar <i class="far fa-trash-alt pointer f-s-17 text-danger m-t-5 m-l-4"></i>
                                    </span>
                                  </div>
                                </div>
                              </div>
                            </div> 
                          </ng-container>
                        </div>
                    </div>

                  </div>
                </div>
              </div>
              <div class="form-group col-lg-12 form__footerBtn m-t-70">
                <div class="text-right">
                  <a class="btn btn-secondary text-white" (click)="cancel()">Cancelar</a>
                  <button type="submit" class="btn btn-primary waves-effect waves-light">
                    <i class="far fa-save m-r-5"></i>
                    Guardar
                    Cambios
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
  </div>
  <app-gallery-tourism (onselectedGalleryEvent)="extendsGalleryTourism($event)"></app-gallery-tourism>
  